import * as Sentry from "@sentry/react"
import { Integrations } from "@sentry/tracing"

export const SentryInit = (
  sentryDSN: string,
  environment: string,
  history: any
) => {
  Sentry.init({
    environment,
    dsn: sentryDSN,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
      })
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}
